import { render } from "./TableComponentGeneric.vue?vue&type=template&id=e2612e76"
import script from "./TableComponentGeneric.vue?vue&type=script&lang=js"
export * from "./TableComponentGeneric.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\src\\Nordlux.Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__